import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { Spin } from 'antd';
import FormBankData from './FormBankData';
import { EnrollmentFormContext } from '../../../../../../providers/EnrollmentFormContextProvider';
import useEnrollmentUpdate from '../../../../../../hooks/useEnrollmentUpdate';

const BankData = ({ onFinish }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [updateEnrollment, isLoading] = useEnrollmentUpdate();

  const handleSubmit = () => {
    const formValues = enrollmentForm.getFieldsValue(true);
    const { dataBankito } = formValues;

    const updatePayload = {
      bankData: {
        ...dataBankito,
        monthlyInvestment: Number(dataBankito.monthlyInvestment?.replace(/\./g, '')),
      },
    };

    updateEnrollment(updatePayload);
    onFinish();
  };
  return (
    <div>
      <Spin spinning={isLoading}>
        <FormBankData onFinish={handleSubmit} />
      </Spin>
    </div>
  );
};
BankData.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default BankData;
